import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import addSSOProvider from '@/API/SSO/addSSOProvider';

const useAddSSOProvider = () => {
    return useMutation({
        mutationFn: addSSOProvider,
        onSuccess: () => {
            toast.success('Microsoft SSO configuration saved successfully!');
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.message ||
                    'Failed to save SSO configuration',
            );
        },
    });
};

export default useAddSSOProvider;
